module.exports = __webpack_public_path__ + "images/LoginPageVector.ca6231d0.svg";